import request from '@/utils/request3'
import store from '@/store'

const serviceName = store.state.serviceName.workOrder

// 查询标书列表
export function getBidList(data) {
  return request({
    url: serviceName + '/bidProject/list',
    method: 'post',
    data
  })
}

// 查询标书详情
export function getBidDetail(id) {
  return request({
    url: serviceName + '/bidProject/query/' + id,
    method: 'get'
  })
}

// 旧版详情接口(保留兼容)
export function getBidDetailOld(id) {
  return request({
    url: serviceName + '/bidProject/info?id=' + id,
    method: 'get'
  })
}

// 新增标书
export function addBid(data) {
  return request({
    url: serviceName + '/bidProject/add',
    method: 'post',
    data
  })
}

// 更新标书
export function updateBid(data) {
  return request({
    url: serviceName + '/bidProject/update',
    method: 'post',
    data
  })
}

// 删除标书
export function deleteBid(id) {
  return request({
    url: serviceName + '/bidProject/delete?id=' + id,
    method: 'post'
  })
}